/**
 * Script contenant les functions Js de stockage des données selon le consentement de l'utilisateur
 * Le plugin "GDPR Cookie Consent" crée plusieurs cookie qui stokent le consentement de l'utilisateur par catégorie de cookie :
 *  
 * -cookielawinfo-checkbox-advertisement        définit le consentement pour les traceurs marketing  ( Adwords,bing,facebook, ...)
 * -cookielawinfo-checkbox-stats                définit le consentement pour les traceurs de type statistique (Analytics, Abtasty)
 * -cookielawinfo-checkbox-non-necessary        définit le consentement pour les traceurs de type personnalisation (agence par défaut, de classe, d'offres d'emploi vues, etc)
 * 
 * Les functions de ce fichier doivent permettre de stocker ou non les infos dans les cookies ou le localstorage selon le consentement donné par l'utilisateur.
 * Pour le cookie cookielawinfo-checkbox-non-necessary relatif aux personnalisations de l'utilisateur, en cas de refus, 
 * on conserve les données dans le session storage au lieu du localstorage. Cela permet de conserver la personnalisation le temps de la visite.
 * 
 */


 (function(w) {
    // Définit l'objet Kinougarde
    w.Kinougarde = Object.assign({},w.Kinougarde);
    var prefix = '__consent_non-necessary_';
    
    /**
     * Function qui gère le  stockage des données selon le consentement de l'utilisateur
     *  - Si il refuse le stockage de ces données à des fins de personnalisation. Les données sont stockées dans le "session storage".
     *  - Si il accepte le stockage de ces données à des fins de personnalisation. Les données sont stockées dans le "local storage".
     * @cname "clé"
     * @cvalue "Valeur" à stocker
     * @expire "nombre de jour avant expiration"
     */
    w.Kinougarde.SetStorage = function(cname,cvalue,expire=60) {
        
        // Gestion de l'expiration des données
        var expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + expire);
        const item = {value: cvalue, expire: expireDate.getTime() }                          

        if (w.Kinougarde.GetCookie("cookielawinfo-checkbox-non-necessary")==="yes") {
            window.localStorage.setItem(prefix + cname,JSON.stringify(item));   
        } else {          
           window.sessionStorage.setItem(prefix + cname,JSON.stringify(item));
        }
    }

    /**
     * Function qui retourne la valeur d'une info stockée selon le consentement de l'utilisateur
     *  - Si il refuse le stockage de ces données à des fins de personnalisation. Les données sont stockées dans le "session storage".
     *  - Si il accepte le stockage de ces données à des fins de personnalisation. Les données sont stockées dans le "local storage".
     * Retourne null si la donnée à expiré
     */
     w.Kinougarde.GetStorage = function(cname) {
        var itemstr = null;
        if (w.Kinougarde.GetCookie("cookielawinfo-checkbox-non-necessary")==="yes") {
          itemstr = window.localStorage.getItem(cname)==='null' ? null : window.localStorage.getItem(prefix + cname);  
        } else {
          itemstr = window.sessionStorage.getItem(cname)==='null' ? null : window.sessionStorage.getItem(prefix + cname);
        }
        if (!itemstr) {
          return null
        }
        try {
          const item = JSON.parse(itemstr);
          const now = new Date();        
          if ( typeof(item.expire)==='undefined' || typeof(item.value)==='undefined' || now.getTime() > item.expire) {
              window.localStorage.removeItem(cname);            
              window.sessionStorage.removeItem(cname);
              return null;
          }      
          return item.value;
          } catch (e) {
              //données non json
              return null;
          }
    }
    
    /**
     * Function appelée sur un clic de mise à jour du consentement de l'utlisateur
     */
    w.Kinougarde.consentementPersonnalisation = function (accepte) {
      try {
          if (accepte) {              
                //Déplacer les infos de personnalisation provisoirement stockées dans le session storage vers le localstorage
                console.info('consent personnalisation Oui');
                Object.keys(window.sessionStorage).forEach( key => {
                    if (key.startsWith(prefix)) {
                        window.localStorage[key]= window.sessionStorage[key];
                        window.sessionStorage.removeItem(key);
                    }
                });
          }
          if (!accepte) {
                //Déplacer les infos de personnalisation stockées dans le localstorage vers le session storage
                console.info('consent personnalisation Non');
                Object.keys(window.localStorage).forEach( key => {
                    if (key.startsWith(prefix)) {
                        window.sessionStorage[key]= window.localStorage[key];
                        window.localStorage.removeItem(key);
                    }
                });
          }
      } catch (e) {
          console.warn("Erreur in ConsentementPersonnalisation");
      }
    };
    
    /**
    * Function appelée par le plugin "GDPR Cookie Consent" après que l'utilisateur ai donné son consentement pour le marketing et la pub
    */
    w.Kinougarde.ConsentementAdvertissement = function () {
      try {
          if (w.Kinougarde.GetCookie('cookielawinfo-checkbox-advertisement')=='yes') {
              // Charge les paramètres globaux de type marketing Utmsource, UtmCible, ...
              w.Kinougarde.GetGlobalQueryParameter();        
          }
          if (w.Kinougarde.GetCookie('cookielawinfo-checkbox-advertisement')=='no') {
              window.localStorage.removeItem('Kinougarde-analytics');              
          }
      } catch (e) {
          console.warn("Erreur in ConsentementAdvertissement");
      }
    };


    /**
     *  Supprime le cookie "viewed_cookie_policy" sur la page /cookies de façon a redemander le consentement de l'utilisateur
     *  après que celui-ci ai clické sur le lien "En savoir plus" de la popup de cookie
     */
    jQuery(function() {      
        try {            
            if (window.location.pathname==="/politique-de-protection-des-donnees-personnelles/") {
                document.cookie = 'viewed_cookie_policy=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
        }
        catch(e) {          
        }

        $('#wt-cli-reject-btn').on('click', function() {
            // Mise à jour du consentement de l'utilisateur via, la box cookie
            Kinougarde.consentementPersonnalisation(false);
        });
        $('#wt-cli-accept-btn').on('click', function() {
            // Mise à jour du consentement de l'utilisateur via, la box cookie
            Kinougarde.consentementPersonnalisation(true);
        });
        $('#wt-cli-privacy-save-btn').on('click', function() {
            // Mise à jour du consentement de l'utilisateur via, la box cookie
            var checked = $('#wt-cli-checkbox-non-necessary').prop('checked');
            Kinougarde.consentementPersonnalisation(checked);
        });
    });


    
    
})(window);